<div class="confirmation-dialog-container">
    <h2 mat-dialog-title></h2>

    <mat-dialog-content *ngIf="!device">
        <span *ngIf="!isBlock">Are you sure you want to block '{{ ifa?.name }}' from the user list ? </span>
        <span *ngIf="isBlock">Are you sure you want to Un-block '{{  ifa?.name }}' from the user list ? </span>
    </mat-dialog-content>
    <mat-dialog-content *ngIf="device">
        <div>
            <span *ngIf="!isBlock">Do you want to Block this device?</span>
            <span *ngIf="isBlock">Do you want to Un-block this device?</span>
        </div>
        <div class="align-h">
            <p class="stretch">Device ID: {{device.deviceId}}</p>
            <p>Device Name: {{device.osName}}</p>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions align="center">
        <button
            tabindex="-1"
            mat-dialog-close
            mat-raised-button
            color="basic"
            class="mat-button-medium"
            (click)="dialogRef.close()"
        >
            Cancel
        </button>
        <button
            mat-raised-button
            color="primary"
            class="mat-button-medium"
            [mat-dialog-close]="true"
            (click)="onConfirmation()"
        >
           <span [innerHtml]=" isBlock ? 'Un-Block': 'Block'"></span> 
        </button>
    </mat-dialog-actions>
</div>
